/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Failed/view.blocks to change it.
import React from 'react'
import StatusInactive from 'DesignSystem/Svgs/StatusInactive/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Failed({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/MessageStatus/Failed",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Failed.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal}`}
>
<StatusInactive
  viewPath={`${viewPath}/StatusInactive`}
 marginRight={2}
 width={10}
 height={10}
 stroke="rgb(237,55,26)"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color="rgb(237,55,26)"
 text="Fail"
/>
</button>
{children}
</React.Fragment>)
}